/**
 * @generated SignedSource<<bdcae6693b20c1dee35683ff7fd75b8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProjectState = "Active" | "Inactive";
import { DateString } from "@watershed/shared-frontend/relay/scalars";
import { DateTimeString } from "@watershed/shared-frontend/relay/scalars";
import { FragmentRefs } from "relay-runtime";
export type FlexibleProjectsList_projects$data = ReadonlyArray<{
  readonly dateRange: {
    readonly end: DateString | null | undefined;
    readonly start: DateString | null | undefined;
  } | null | undefined;
  readonly dueDate: DateString | null | undefined;
  readonly id: string;
  readonly keyEvents: {
    readonly created: {
      readonly actor: {
        readonly displayName: string;
        readonly id: string;
      } | null | undefined;
      readonly dateTime: DateTimeString;
    };
  };
  readonly name: string;
  readonly state: ProjectState;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"FlexibleProjectProgress_project" | "FlexibleProjectRowActions_project">;
  readonly " $fragmentType": "FlexibleProjectsList_projects";
}>;
export type FlexibleProjectsList_projects$key = ReadonlyArray<{
  readonly " $data"?: FlexibleProjectsList_projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlexibleProjectsList_projects">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "FlexibleProjectsList_projects",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DateInterval",
      "kind": "LinkedField",
      "name": "dateRange",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectKeyEvents",
      "kind": "LinkedField",
      "name": "keyEvents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventMetadata",
          "kind": "LinkedField",
          "name": "created",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dateTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "actor",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "Defer",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlexibleProjectProgress_project"
        }
      ]
    },
    {
      "kind": "Defer",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlexibleProjectRowActions_project"
        }
      ]
    }
  ],
  "type": "Project",
  "abstractKey": null
};
})();

(node as any).hash = "1d326519d01c0822649bb10426afb693";

export default node;
